import { Link, useNavigate } from "react-router-dom";
import shared1 from "../../../assets/images/Static/HowItWorks/shared1.webp";
import shared2 from "../../../assets/images/Static/HowItWorks/shared2.webp";
import shared3 from "../../../assets/images/Static/HowItWorks/shared3.webp";

import shared1A from "../../../assets/images/Static/shared/shared1A.webp";
import shared2A from "../../../assets/images/Static/shared/shared2A.webp";
import shared3A from "../../../assets/images/Static/shared/shared3A.webp";
import sharedphone2 from "../../../assets/images/Static/shared/sharedphone2.png";
import sharedimg from "../../../assets/images/Static/shared/shared.png";
import { GetAllProductViewd } from "../../../features/RecentlyViewed/RecentlyViewed";
import sharedar from "../../../assets/images/Static/shared/sharedar.png";
import sharedphonear from "../../../assets/images/Static/shared/sharedphonear.png";

import {
  GetProductAlsoLike,
  GetProductJustViewdd,
  GetProductNewDrops,
  GetProductFromSeller,
  GetProductTopPicks,
  GetLibasProduct,
  GetAllChanel,
  GetAllAmina,
  GetAllPradaReEdition,
  GetAllChanelBoy,
  GetAllBottega,
  GetAllHermes,
  IsProductAlsoLike,
  IsDrops,
  IsJustView,
  IsTopPicks,
  IsProductFromSeller,
  IsProductLibas,
  GetAllProductVintage,
  IsVintage,
  IsChanel,
  IsAmina,
  IsPradaReEdition,
  IsChanelBoy,
  IsBottega,
  IsHermes,
  IsBirkin,
  GetAllBirkin,
  GetAllBurberry,
  IsBurberry,
  GetAllLV,
  GetAllDG,
  GetAllMM,
  GetAllZadig,
  GetAllDisel,
  GetAllGucci,
  IsDG,
  IsGucci,
  IsDisel,
  IsLV,
  IsMM,
  IsZadug,
  SetSelectdPage,
  SetSizeFilter,
  SetTopSizeFilter,
  getAllProductOnline,
  getLastDoc
} from "../../../features/Products/ProductSlice";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { Navigation } from "../../../utils/navigation/navigation";

function Shared() {
  const navigate = useNavigate();
  const { t,i18n } = useTranslation();
  const dispatch = useDispatch();
  useEffect(() => {
    
    dispatch(SetSelectdPage(0))
    dispatch(SetSizeFilter([]))
    dispatch(SetTopSizeFilter([]))
    dispatch(getAllProductOnline([])) 
    dispatch(getLastDoc(null)) 
  }, []);
 
  useEffect(() => {
    dispatch(GetProductJustViewdd([]));
    dispatch(GetProductAlsoLike([]));
    dispatch(GetProductFromSeller([]));
    dispatch(GetProductNewDrops([]));
    dispatch(GetProductTopPicks([]));
    dispatch(GetAllProductViewd([]));
    dispatch(GetLibasProduct([]));
    dispatch(GetAllProductVintage([]));
    dispatch(GetAllChanel([]));
    dispatch(GetAllAmina([]));
    dispatch(GetAllPradaReEdition([]));
    dispatch(GetAllChanelBoy([]));
    dispatch(GetAllBottega([]));
    dispatch(GetAllHermes([]));
    dispatch(GetAllBirkin([]));
    dispatch(GetAllBurberry([]));
    dispatch(IsBurberry(false));
    
    dispatch(GetAllDG([]));
    dispatch(IsDG(false));

    dispatch(GetAllLV([]));
    dispatch(IsLV(false));

    dispatch(GetAllDisel([]));
    dispatch(IsDisel(false));

    dispatch(GetAllGucci([]));
    dispatch(IsGucci(false));

    dispatch(GetAllMM([]));
    dispatch(IsMM(false));

    dispatch(GetAllZadig([]));
    dispatch(IsZadug(false))
    dispatch(IsJustView(false));
    dispatch(IsDrops(false));
    dispatch(IsTopPicks(false));
    dispatch(IsProductFromSeller(false));
    dispatch(IsProductAlsoLike(false));
    dispatch(IsProductLibas(false));
    dispatch(IsVintage(false));
    dispatch(IsChanel(false));
    dispatch(IsAmina(false));
    dispatch(IsPradaReEdition(false));
    dispatch(IsChanelBoy(false));
    dispatch(IsBottega(false));
    dispatch(IsHermes(false));
    dispatch(IsBirkin(false));
  }, []);
  return (
    <>

      {/* <div className="container-fluid p-0 me-0 pt-5 pbs">
        <div
          className="d-flex flex-row  scroll flex-nowrap padding-inlineCards justify-content-between  px-0  pt-md-5 "
          id="style-2"
        >
          <div
            className={`text-decoration ${i18n.language=="en"?`pe-md-0 me-3`:``}`}
            style={{ cursor: "pointer" }}
            onClick={() =>
              dispatch(IsDrops(true)) &
              Navigation(navigate,`/products?topic=newdrops`)
            }
          >
            <div className="shared-img position-relative  ">
              {i18n.language=='en'?<img src={shared1} alt="Fresh drops of designer clothing"  className="100 img-fluid shared-img" />:
              <img src={shared1A} alt="Fresh drops of designer clothing" className="100 img-fluid shared-img" />
              }
              <div className="brand-txt2 text-center ">
                   {t("work9")}
                  </div>
            </div>
          </div>
          <div
            className="text-decoration pe-md-0 me-3 ms-1 "
            style={{ cursor: "pointer" }}
            onClick={() =>
              dispatch(IsTopPicks(true)) &
              Navigation(navigate,`/products?topic=TopPicks`)
            }
          >
            <div className="shared-img position-relative">
            {i18n.language=='en'?<img src={shared2} alt="Top picks of second hand  luxuries"className="100 img-fluid shared-img" />:
              <img src={shared2A} alt="Top picks of second hand  luxuries" className="100 img-fluid shared-img" />
              }
              <div className="brand-txt2 text-center ">
                   {t("work10")}<br/>
                   {t("work100")}
                  </div>
            </div>
          </div>
          <div
            className="text-decoration  ms-1 "
            style={{ cursor: "pointer" }}
            onClick={() =>
              dispatch(IsVintage(true)) &
              Navigation(navigate,`/products?topic=Vintage`)
            }
          >
            <div className="shared-img position-relative ">
            {i18n.language=='en'?<img src={shared3} alt="Vintage finds of scond hand esigner clothing" className="100 img-fluid shared-img" />:
              <img src={shared3A} alt="Vintage finds of scond hand esigner clothing" className="100 img-fluid shared-img" />
              }
              <div className="brand-txt2 text-center ">
                   {t("work11")}
                  </div>
            </div>
          </div>
        </div>
      </div> */}
      {/* <div>
<img src={sharedimg} className="img-fluid"/>
      </div> */}
      {/* <div className="container-fluid p-0 me-0">
     <div className="d-flex flex-row  scroll flex-nowrap padding-inlineCards justify-content-between  px-0 pt-4 pb-4 pt-md-5 pb-md-5 "  id="style-2">
         <div>

        
         <div className="card card-width-shared border-0 justify-content-center d-flex">
          <div>

        
          <div className="justify-content-center d-flex">
            
             <img src={Returns} className="shared-img2"/>
             </div>
             <div className="justify-content-center d-flex">
             <Link to="/" className="shared-txt">
              {t("Shipping and Returns")}
             </Link>
             </div>
             </div>
          
         </div>
         </div>
         <div>

         <div className="card  card-width-shared border-0 justify-content-center d-flex">
          <div  className="justify-content-center d-flex">
            
             <img src={secure} className="shared-img3"/>
             </div>
             <div  className="justify-content-center d-flex">
             <Link to="/" className="shared-txt pt-1">
              {t("Secure Payments")}
             </Link>
             </div>
            
             </div>
         </div>
         <div>
         <div className=" card card-width-shared border-0 justify-content-center d-flex">
          <div  className="justify-content-center d-flex">
            
             <img src={customer} className="shared-img4"/>
             </div>
             <div  className="justify-content-center d-flex">
             <Link to="/" className="shared-txt">
              {t("Customer Support")}
             </Link>
             </div>
            
          
         </div>
         </div>
         </div>
         </div> */}
      {/* <div className=" d-none pt-4 pb-4 pt-md-5 pb-md-5 bg-payment d-md-flex " style={{justifyContent:"space-around"}}>
         <div  className="justify-content-center d-flex">
            <div>

            <div  className="justify-content-center d-flex">
            <img src={Returns} className="shared-img2"/>
             
            </div>
            <div  className="justify-content-center d-flex">
            <Link to="/" className="shared-txt pt-1">
          
            {t("Shipping and Returns")}
            
            </Link>
            </div>
            </div>
            </div>
            <div  className="justify-content-center d-flex" >
            <div>

            <div  className="justify-content-center d-flex">
            <img src={secure} className="shared-img3"/>
            </div>
            <div  className="justify-content-center d-flex">
            <Link to="/" className="shared-txt pt-md-3 pt-2">
             {t("Secure Payments")}
            </Link>
            </div>
            </div>
            </div>
            <div  className="justify-content-center d-flex">
            <div>

            <div  className="justify-content-center d-flex">
            <img src={customer} className="shared-img4"/>
            </div>
            <div  className="justify-content-center d-flex">
            <Link to="/" className="shared-txt pt-1">
            {t("Customer Support")}
            </Link>
            </div>
            </div>
            </div>
         </div> */}


      {/* <div className="justify-content-center d-none d-md-block bg-payment pt-3 pb-3">
        {i18n.language=="en"?
                <img src={sharedimg} alt="Libas' shipping and return, secure payments and customer support" className="img-fluid px-3" />

      :
      <img src={sharedar} className="img-fluid px-5"  alt="Libas' shipping and return, secure payments and customer support" />

      }
      </div>
      <div className="justify-content-center d-flex d-md-none bg-payment pt-3 pb-3">
      {i18n.language=="en"?
             <img src={sharedphone2} className="img-fluid px-3"  alt="Libas' shipping and return, secure payments and customer support" />
      :
      <img src={sharedphonear} className="img-fluid px-3"  alt="Libas' shipping and return, secure payments and customer support"/>

      }
       
      </div> */}
    </>
  );
}

export default Shared;
